import { useFeatureFlagEnabled } from 'posthog-js/react';

export type FEATURE_FLAGS =
  | 'fe-allow-images-in-doc-editor'
  | 'fe-allow-multi-file-support'
  | 'fe-allow-new-profile'
  | 'fe-allow-overlay-click-nexthink-workaround'
  | 'fe-allow-refinement'
  | 'fe-allow-table-templates'
  | 'fe-allow-tablebuttonbar-add-image'
  | 'fe-allow-tablebuttonbar-extract-table'
  | 'fe-allow-template-management'
  | 'fe-auto-reviewers'
  | 'fe-auto-update'
  | 'fe-better-exports'
  | 'fe-better-qc'
  | 'fe-content-templates-org'
  | 'fe-custom-templates'
  | 'fe-ind-tables'
  | 'fe-session-auth'
  | 'fe-show-templated-table-instructions'
  | 'fe-templates-allow-module-3'
  | 'fe-version-control'
  | 'fe-gap-analysis'
  | 'fe-m3-tables';

/**
 * Checks if a feature is enabled or not. If the result is undefined, probably the feature is
 * either missing from the posthog env, or loading.
 * @param feature the name of the feature flag
 * @returns a bool specifying if it's enabled or not, otherwise undefined
 */
export const useIsFeatureEnabled = (
  feature: FEATURE_FLAGS,
): boolean | undefined => {
  return useFeatureFlagEnabled(feature);
};
